module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copy"
  }), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("Publisher:")]), _vm._v(" Amy Marson")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("Creative Director:")]), _vm._v(" Gailen Runge")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("Acquisitions Editor:")]), _vm._v(" Roxane Cerda")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("Managing Editor:")]), _vm._v(" Liz Aneloski")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("Technical Editor:")]), _vm._v(" Gailen Runge")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("Cover/Book Designer:")]), _vm._v(" April Mostek")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("Production Coordinator:")]), _vm._v(" Zinnia Heinzmann")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("Production Editor:")]), _vm._v(" Alice Mace Nakanishi")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("Illustrator:")]), _vm._v(" Linda Johnson")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("Photo Assistant:")]), _vm._v(" Mai Yong Vang")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("Cover photography")]), _vm._v(" by Lucy Glover")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("Subject photography")]), _vm._v(" by Lucy Glover and "), _c('br'), _c('span', {
    staticClass: "red"
  }, [_vm._v("instructional photography")]), _vm._v(" by Mai Yong Vang of C&T Publishing, Inc., unless otherwise noted")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Published by C&T Publishing, Inc., P.O. Box 1456, Lafayette, CA 94549")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg3.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c96776b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/03_Copy.vue
// module id = 60
// module chunks = 0